/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : SearchSelectProjectTextField.jsx
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
/**
 * @author : Narender - narender@au79consulting.com
 * @Date : 11-03-2025
 * @description : Custom reusable search select project text field
 */
import React, { useEffect, useState } from "react";
import SearchSelectTextFieldN from "./SearchSelectTextFieldN";
import { useDispatch, useSelector } from "react-redux";
import { HandleApiActions, projectConfigAPI } from "../../redux/actions";
import { selectProjectAction } from "../../redux/actions/projectConfigActions";

function SearchSelectProjectTextField({ txtFldStyle }) {
  /**
   * ===================== State Initialization =====================
   */
  /** ============== Redux ============== **/
  const dispatch = useDispatch();
  const projects = useSelector(
    (state) => state?.projectConfigReducer?.projects,
  );
  const selectedProjectDetails = useSelector(
    (state) => state?.projectConfigReducer?.selectedProjectDetails,
  );
  /** ============== Select Project ============== **/
  const [projectOptionsList, setProjectOptionsList] = useState([]);

  /**
   * ===================== Effect Hooks =====================
   */
  // Fetches projects when any of the dependencies change.
  // Dependencies: null
  useEffect(() => {
    getProjects();
  }, []);
  // Updates the project options list when the projects data changes.
  // Dependencies: projects
  useEffect(() => {
    const filteredProjectOptionsList = projects?.map((el) => ({
      value: el?.project_id,
      label: el?.name,
    }));
    setProjectOptionsList(filteredProjectOptionsList);
  }, [projects]);

  /**
   * ===================== API Call Functions =====================
   */

  const getProjects = async () => {
    const apiDetails = projectConfigAPI?.get_projects_main;
    await dispatch(
      HandleApiActions({
        ...apiDetails,
        show_toast: false,
        params: {
          order_by_column: "created_at",
          order_by_sort: "DESC",
          page_size: 10000,
          page_number: 1,
        },
      }),
    );
  };

  /**
   * ===================== UI & State Management Functions =====================
   */

  return (
    // Select Project
    <SearchSelectTextFieldN
      size={"small"}
      placeholder={"Type to search..."}
      noOptionsText={"No projects found"}
      optionsList={projectOptionsList || []}
      selectedValue={
        selectedProjectDetails?.name
          ? {
            value: String(selectedProjectDetails?.project_id),
            label: selectedProjectDetails?.name,
          }
          : null
      }
      handleValueChange={(event, value) => {
        // Store the selected project in the redux store

        dispatch(selectProjectAction(value?.value));
      }}
      txtFldStyle={txtFldStyle}
    />
  );
}

export default SearchSelectProjectTextField;
